<template>
  <div class="row">
		<div class="column-3 item">
			<v-search-left @changeFiltros="changeFiltros" :filtros="filtros"></v-search-left>
		</div>
		<v-lt-pedidos :filtros="filtros" ref="listagem"></v-lt-pedidos>
		<vue-element-loading :active="loading" spinner="bar-fade-scale" is-full-screen/>
	</div>
</template>
<script>
	export default {
		props: {
			filters : [Object, Array]
		},
		data() {
			return {
				loading: false,
				loadingSave: false,
				filtros: this.filters
			}
		},
		methods: {
			changeFiltros(filtros) {
				this.$refs.listagem.buscar(Object.assign({}, ...filtros));
			}
		},
		mounted() {
			if (this.filtros) 
			{
				if (this.filtros.dataIni)
				{
					this.filtros.dataIni = this.filtros.dataIni.replace('*', '/');
					this.filtros.dataIni = this.filtros.dataIni.replace('*', '/');
				}
				if (this.filtros.dataFim)
				{
					this.filtros.dataFim = this.filtros.dataFim.replace('*', '/');
					this.filtros.dataFim = this.filtros.dataFim.replace('*', '/');
				}
			}
		}
	}
</script>